import { useEffect, useState } from 'react'
import { request } from 'graphql-request'
import { shopClient } from 'lib/shopify.client'
import { recommendedProductsQuery } from 'lib/sanity.queries'
import { ProductProvider } from '@shopify/hydrogen-react'
import { ProductCard } from 'components/Product/ProductCard'

export const RelatedProducts = ({ id }) => {
  const [products, setProducts] = useState<any>([])
  useEffect(() => {
    request({
      url: shopClient.getStorefrontApiUrl(),
      document: recommendedProductsQuery,
      variables: {
        id: id,
      },
      requestHeaders: shopClient.getPublicTokenHeaders(),
    })
      .then((res: any) => {
        if (res && res.productRecommendations) {
          setProducts(res.productRecommendations)
        }
      })
      .catch((err) => console.error(err))
  }, [])

  return (
    <div>
      <div className="p-20 py-12 text-16 leading-120 text-darkGray">
        <h2>Related products</h2>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4">
        {products.map((product, i) => {
          if (i > 3) return null
          return (
            <ProductProvider
              data={product}
              key={product.id}
              initialVariantId={null}
            >
              <ProductCard product={product} />
            </ProductProvider>
          )
        })}
      </div>
    </div>
  )
}
